import { render, staticRenderFns } from "./allScore.vue?vue&type=template&id=10e5dd30&scoped=true&"
import script from "./allScore.vue?vue&type=script&lang=js&"
export * from "./allScore.vue?vue&type=script&lang=js&"
import style0 from "./allScore.vue?vue&type=style&index=0&id=10e5dd30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5dd30",
  null
  
)

export default component.exports